import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface ICardCommissionDataTableRowFormMeta {
    transactionCode: FormInputMeta;
    bankGroup: FormInputMeta;
    dc: FormInputMeta;
    ratio: FormInputMeta;
    fix: FormInputMeta;
    minimum: FormInputMeta;
    maximum: FormInputMeta;

    schema: any;
}

const cardCommissionDataTableRowFormMeta = {} as ICardCommissionDataTableRowFormMeta;

cardCommissionDataTableRowFormMeta.transactionCode = {
  name: "transactionCode",
  type: "select",
  label: "Code Transaction",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

cardCommissionDataTableRowFormMeta.bankGroup = {
  name: "bankGroup",
  type: "select",
  label: "Grp. Banque",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

cardCommissionDataTableRowFormMeta.dc = {
  name: "dc",
  type: "select",
  label: "D/C",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

cardCommissionDataTableRowFormMeta.ratio = {
  name: "ratio",
  type: "number",
  label: "Taux",
  placeholder: "",
  validation: yup.number().min(0, "La valeur doit être supérieur ou égale à 0").required("Champ obligatoire !")
};

cardCommissionDataTableRowFormMeta.fix = {
  name: "fix",
  type: "number",
  label: "Fixe",
  placeholder: "",
  validation: yup.number().min(0, "La valeur doit être supérieur ou égale à 0").required("Champ obligatoire !")
};

cardCommissionDataTableRowFormMeta.minimum = {
  name: "minimum",
  type: "number",
  label: "Minimum",
  placeholder: "",
  validation: yup.number().min(0, "La valeur doit être supérieur ou égale à 0").required("Champ obligatoire !")
};

cardCommissionDataTableRowFormMeta.maximum = {
  name: "maximum",
  type: "number",
  label: "Maximum",
  placeholder: "",
  validation: yup.number().min(0, "La valeur doit être supérieur ou égale à 0").required("Champ obligatoire !")
};


cardCommissionDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(cardCommissionDataTableRowFormMeta));

export default cardCommissionDataTableRowFormMeta;